import axios from 'axios'
import router from '@/router/routers'
import { Notification, MessageBox } from 'element-ui'
import store from '../store'
import { getToken } from '@/utils/auth'

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
const service = axios.create({
	baseURL: ((process.env.NODE_ENV == "production" && GLOBAL_CONFIG && GLOBAL_CONFIG.APP_BASE_API)? GLOBAL_CONFIG.APP_BASE_API : process.env.VUE_APP_BASE_API), // api 的 base_url
	timeout: 3000000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(config => {
	const isToken = (config.headers || {}).isToken === false
	if (getToken() && !isToken) {
		config.headers['Authorization'] = 'Bearer ' + getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
	}
	return config
},
	error => {
		// Do something with request error
		console.log(error) // for debug
		Promise.reject(error)
	}
)

// response 拦截器
service.interceptors.response.use(response => {
	const code = response.data.code
	const resCode = response.code
	if (code == -10 || resCode == -10) {
		MessageBox.confirm(
			'登录状态已过期，请重新登录',
			'系统提示',
			{
				showCancelButton: false,
				closeOnClickModal: false,
				closeOnPressEscape: false,
				showClose: false,
				confirmButtonText: '重新登录',
				type: 'warning'
			}
		).then(() => {
			store.dispatch('LogOut').then(() => {
				location.reload() // 为了重新实例化vue-router对象 避免bug
			})
		})
	} else {
		return response.data
	}
},
	error => {
		let code = 0
		try {
			code = error.response.data.status
		} catch (e) {
			if (error.toString().indexOf('Error: timeout') !== -1) {
				Notification.error({
					title: '网络请求超时',
					duration: 5000
				})
				return Promise.reject(error)
			}
		}
		if (code) {
			if (code === 401) {

			} else if (code === 403) {
				router.push({ path: '/401' })
			} else {
				const errorMsg = error.response.data.message
				if (errorMsg !== undefined) {
					Notification.error({
						title: errorMsg,
						duration: 5000
					})
				}
			}
		} else {
			this.$message.error('服务器错误！');
			// Notification.error({
			//   title: '接口请求失败',
			//   duration: 5000
			// })
		}
		return Promise.reject(error)
	}
)
export default service
